import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Paper } from "@mui/material";
import { PAY_FINE } from "@/graphql/mutations/financial";
import { useMutation } from "@apollo/client";
import { errorToast } from "@/utils/toasts";
import TitlePayment, { PreTitlePayment } from "./TitlePayment";
import BankConnectProgress from "./BankConnectProgress";

export default function OnlinePayment({ preTitle, handleClose }) {
    const [payFine, { loading }] = useMutation(PAY_FINE);

    const onSubmit = () => {
        payFine({
            onCompleted: (data) => {
                const nextUrl = data?.payFine?.nextUrl;

                handleClose();
                if (nextUrl) window.location.replace(nextUrl);
            },
            onError: (error) => {
                handleClose();
                errorToast(error?.message);
            },
        });
    };

    return (
        <>
            {loading && <BankConnectProgress />}
            <Paper variant="outlined">
                <Grid
                    container
                    rowSpacing={1}
                    sx={{ padding: { xs: "10px", md: "20px" } }}
                >
                    <Grid item xs={12}>
                        {preTitle && (
                            <PreTitlePayment>{preTitle}</PreTitlePayment>
                        )}
                        <TitlePayment>پرداخت آنلاین</TitlePayment>
                    </Grid>
                    <Grid item xs={12}>
                        می توانید با استفاده از کارت بانکی و به صورت آنلاین
                        پرداخت خود را انجام دهید.
                    </Grid>
                    <Grid container xs={12} display="flex" alignItems="center">
                        <Grid item xs={12} sm={8} />
                        <Grid item xs={12} sm={4}>
                            <Button
                                onClick={() => onSubmit()}
                                disabled={loading}
                                variant="contained"
                                size="small"
                                sx={{ whiteSpace: "nowrap" }}
                                fullWidth
                            >
                                پرداخت آنلاین
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
}
